import ActionTypes from '../constants';

const initialState = {
    insuranceStatements: {},
    investigationSchedule: {},
    estimateSchedule: {},
    priceStatement: {},
    jobCardSchedule: {},
    costStatement: {},
    statementInsurance: {},
};

const reportReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.GETINSURANCESTATEMENTSUCCESS:
            return {
                ...state,
                insuranceStatements: action.payload,
            }
        case ActionTypes.GETINVESTIGATIONSCHEDULESUCCESS:
            return {
                ...state,
                investigationSchedule: action.payload,
            }
        case ActionTypes.GETESTIMATESCHEDULESUCCESS:
            return {
                ...state,
                estimateSchedule: action.payload,
            }
        case ActionTypes.GETPRICESTATEMENTSUCCESS:
            return {
                ...state,
                priceStatement: action.payload,
            }
        case ActionTypes.GETJOBCARDSCHEDULESUCCESS:
            return {
                ...state,
                jobCardSchedule: action.payload,
            }
        case ActionTypes.GETCOSTSTATEMENTSUCCESS:
            return {
                ...state,
                costStatement: action.payload,
            }
        case ActionTypes.GETSTATEMENTMEETHAQTAKAFULINSURANCESUCCESS:
            return {
                ...state,
                statementInsurance: action.payload,
            }
        default:
            return state;
    }
}

export default reportReducer;